import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-organization-confirmed',
  imports: [
    ButtonModule,
    RouterModule,
    TranslatePipe
  ],
  templateUrl: './organization-confirmed.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class OrganizationConfirmedComponent {

}
